import React from 'react';

export const AlertSecond = ({
  width = '14',
  height = '14',
  fill = '#FC2C2C',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7" r="6" fill="none" stroke={fill} strokeWidth="2" />
    <rect x="6" y="3.5" width="2" height="4" fill={fill} rx="1" />
    <circle cx="7" cy="9.5" r="0.5" stroke={fill} strokeWidth="1" />
  </svg>
);
